"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bulkSetSubscriptionChannel = exports.updatePreferences = exports.setPreferenceEnabled = exports.fetchAndInitPreferences = exports.reloadInboxPage = exports.loadMoreNotifications = exports.fetchInboxPage = exports.applyNotificationAction = exports.markAllRead = exports.restore = exports.updateLanguage = exports.archive = exports.markUnread = exports.markRead = exports.markClicked = exports.markOpened = void 0;
// api.ts (fix action aliases + remove broken references)
var axios_1 = __importDefault(require("axios"));
var notificationsStore_1 = require("./storage/notificationsStore");
var preferencesStore_1 = require("./storage/preferencesStore");
var preferencesStore = __importStar(require("./storage/preferencesStore"));
var Toast_1 = require("../Generic/Toast");
var Lang_1 = require("../Lang");
var csrfToken = function () { var _a, _b; return (_b = (_a = document.querySelector('meta[name="csrf-token"]')) === null || _a === void 0 ? void 0 : _a.content) !== null && _b !== void 0 ? _b : null; };
var headers = function () { return (__assign({ Accept: 'application/json', 'Content-Type': 'application/json' }, (csrfToken() ? { 'X-CSRF-TOKEN': csrfToken() } : {}))); };
function markOpened(ids) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!ids.length)
                        return [2 /*return*/];
                    return [4 /*yield*/, postActions({ ids: ids, action: 'opened' }).catch(function () { })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.markOpened = markOpened;
function markClicked(ids) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!ids.length)
                        return [2 /*return*/];
                    return [4 /*yield*/, postActions({ ids: ids, action: 'clicked' }).catch(function () { })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.markClicked = markClicked;
var postActions = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, axios_1.default.post('/api/v2/students/notifications/actions', payload, {
                    headers: headers(),
                    withCredentials: true,
                })];
            case 1:
                res = _c.sent();
                return [2 /*return*/, ((_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : res.data)];
        }
    });
}); };
// Drop-in aliases (prefer these everywhere)
function markRead(id) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            (0, notificationsStore_1.markReadLocally)(id);
            return [2 /*return*/, postActions({ ids: [id], action: 'read' })];
        });
    });
}
exports.markRead = markRead;
function markUnread(id) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            (0, notificationsStore_1.markUnreadLocally)(id);
            return [2 /*return*/, postActions({ ids: [id], action: 'unread' })];
        });
    });
}
exports.markUnread = markUnread;
function archive(id) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            (0, notificationsStore_1.archiveLocally)(id);
            return [2 /*return*/, postActions({ ids: [id], action: 'archive' })];
        });
    });
}
exports.archive = archive;
function updateLanguage(lang) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios_1.default.post("/api/v2/students/notifications/preferences/language", { language: lang })
                        .then(function (s) {
                        if (s.status === 200) {
                            (0, Toast_1.toast)({ message: (0, Lang_1.__)('Notification language updated successfully') });
                        }
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.updateLanguage = updateLanguage;
;
function restore(id) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            (0, notificationsStore_1.restoreLocally)(id);
            return [2 /*return*/, postActions({ ids: [id], action: 'restore' })];
        });
    });
}
exports.restore = restore;
function markAllRead() {
    return __awaiter(this, void 0, void 0, function () {
        var ids;
        return __generator(this, function (_a) {
            ids = (0, notificationsStore_1.getNotifications)()
                .filter(function (n) { return !n.archived_at && !n.read_at; })
                .map(function (n) { return n.id; });
            if (ids.length === 0)
                return [2 /*return*/, null];
            (0, notificationsStore_1.markAllReadLocally)();
            return [2 /*return*/, postActions({ ids: ids, action: 'read' })];
        });
    });
}
exports.markAllRead = markAllRead;
// If you still want a generic batch helper, it must call *Locally fns* (not the async aliases)
function applyNotificationAction(ids, action) {
    return __awaiter(this, void 0, void 0, function () {
        var _i, ids_1, id;
        return __generator(this, function (_a) {
            for (_i = 0, ids_1 = ids; _i < ids_1.length; _i++) {
                id = ids_1[_i];
                if (action === 'read')
                    (0, notificationsStore_1.markReadLocally)(id);
                if (action === 'unread')
                    (0, notificationsStore_1.markUnreadLocally)(id);
                if (action === 'archive')
                    (0, notificationsStore_1.archiveLocally)(id);
                if (action === 'restore')
                    (0, notificationsStore_1.restoreLocally)(id);
            }
            return [2 /*return*/, postActions({ ids: ids, action: action })];
        });
    });
}
exports.applyNotificationAction = applyNotificationAction;
// ---- Inbox pagination ----
function fetchInboxPage(filter, query, page) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var params, res;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    params = new URLSearchParams({ filter: filter, page: String(page), per_page: '20' });
                    if (query.trim())
                        params.set('q', query.trim());
                    return [4 /*yield*/, axios_1.default.get("/api/v2/students/notifications?".concat(params), {
                            headers: headers(),
                            withCredentials: true,
                        })];
                case 1:
                    res = _c.sent();
                    return [2 /*return*/, ((_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : res.data)];
            }
        });
    });
}
exports.fetchInboxPage = fetchInboxPage;
function loadMoreNotifications(serverFilter, query) {
    return __awaiter(this, void 0, void 0, function () {
        var page, payload;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if ((0, notificationsStore_1.getLoadingMore)() || !(0, notificationsStore_1.getHasMore)())
                        return [2 /*return*/];
                    (0, notificationsStore_1.setLoadingMore)(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    page = (0, notificationsStore_1.getPagination)().page;
                    return [4 /*yield*/, fetchInboxPage(serverFilter, query, page + 1)];
                case 2:
                    payload = _a.sent();
                    (0, notificationsStore_1.appendNotifications)(payload.notifications, payload.pagination);
                    return [3 /*break*/, 4];
                case 3:
                    (0, notificationsStore_1.setLoadingMore)(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.loadMoreNotifications = loadMoreNotifications;
function reloadInboxPage(serverFilter, query) {
    return __awaiter(this, void 0, void 0, function () {
        var payload;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    (0, notificationsStore_1.setLoadingMore)(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, fetchInboxPage(serverFilter, query, 1)];
                case 2:
                    payload = _a.sent();
                    (0, notificationsStore_1.replaceNotifications)(payload.notifications, payload.pagination);
                    return [3 /*break*/, 4];
                case 3:
                    (0, notificationsStore_1.setLoadingMore)(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.reloadInboxPage = reloadInboxPage;
// ---- Preferences ----
var preferencesFetchStarted = false;
function fetchAndInitPreferences() {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var res, data, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if ((0, preferencesStore_1.isPreferencesInitialised)() || preferencesFetchStarted)
                        return [2 /*return*/];
                    preferencesFetchStarted = true;
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios_1.default.get('/api/v2/students/notifications/preferences', {
                            headers: headers(),
                            withCredentials: true,
                        })];
                case 2:
                    res = _d.sent();
                    data = ((_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : res.data);
                    (0, preferencesStore_1.initPreferences)(data);
                    return [3 /*break*/, 4];
                case 3:
                    _c = _d.sent();
                    preferencesFetchStarted = false;
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.fetchAndInitPreferences = fetchAndInitPreferences;
function postPreferences(payload) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var res;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, axios_1.default.post('/api/v2/students/notifications/preferences', payload, {
                        headers: headers(),
                        withCredentials: true,
                    })
                        .then(function (s) {
                        if (s.status === 200) {
                            (0, Toast_1.toast)({ message: (0, Lang_1.__)('Notification preferences updated successfully') });
                        }
                        return s;
                    })];
                case 1:
                    res = _c.sent();
                    return [2 /*return*/, ((_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : res.data)];
            }
        });
    });
}
// Drop-in alias: keep existing call-sites unchanged
function setPreferenceEnabled(args) {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function () {
        var payload, _i, _e, p;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    // optimistic local update: you said you suffixed with Locally
                    (_b = (_a = preferencesStore).setPreferenceEnabledLocally) === null || _b === void 0 ? void 0 : _b.call(_a, args);
                    return [4 /*yield*/, postPreferences({
                            preferences: [{ kind: args.kind, channel: args.channel, enabled: args.enabled }],
                        })];
                case 1:
                    payload = _f.sent();
                    // Optional reconcile hook if you have one; otherwise omit.
                    if (Array.isArray(payload.preferences)) {
                        for (_i = 0, _e = payload.preferences; _i < _e.length; _i++) {
                            p = _e[_i];
                            (_d = (_c = preferencesStore).upsertPreference) === null || _d === void 0 ? void 0 : _d.call(_c, p);
                        }
                    }
                    return [2 /*return*/, payload];
            }
        });
    });
}
exports.setPreferenceEnabled = setPreferenceEnabled;
function updatePreferences(preferences) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var payload, _i, _c, p;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, postPreferences({ preferences: preferences })];
                case 1:
                    payload = _d.sent();
                    if (Array.isArray(payload.preferences)) {
                        for (_i = 0, _c = payload.preferences; _i < _c.length; _i++) {
                            p = _c[_i];
                            (_b = (_a = preferencesStore).upsertPreference) === null || _b === void 0 ? void 0 : _b.call(_a, p);
                        }
                    }
                    return [2 /*return*/, payload];
            }
        });
    });
}
exports.updatePreferences = updatePreferences;
/**
 * Subscribe/unsubscribe every list in an org for a single channel.
 * Reconciles Web/Mobile preference state locally from the response; leaves the
 * caller to reconcile the email column (from `changed`) and to toast. Hits the
 * subscriptions controller, so it does NOT fire the preferences-update toast.
 */
function bulkSetSubscriptionChannel(args) {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function () {
        var res, data, prefs, _i, prefs_1, p;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4 /*yield*/, axios_1.default.post('/api/subscriptions/bulk', { org: args.org, channel: args.channel, enabled: args.enabled, lang: args.lang }, { headers: headers(), withCredentials: true })];
                case 1:
                    res = _e.sent();
                    data = (_a = res.data) !== null && _a !== void 0 ? _a : {};
                    prefs = (_b = data === null || data === void 0 ? void 0 : data.preferences) === null || _b === void 0 ? void 0 : _b.preferences;
                    if (Array.isArray(prefs)) {
                        for (_i = 0, prefs_1 = prefs; _i < prefs_1.length; _i++) {
                            p = prefs_1[_i];
                            (_d = (_c = preferencesStore).upsertPreference) === null || _d === void 0 ? void 0 : _d.call(_c, p);
                        }
                    }
                    return [2 /*return*/, {
                            changed: Array.isArray(data.changed) ? data.changed : [],
                            failed: Array.isArray(data.failed) ? data.failed : [],
                            preferences: data.preferences,
                        }];
            }
        });
    });
}
exports.bulkSetSubscriptionChannel = bulkSetSubscriptionChannel;
